import i18n from 'i18n';

export const CROP_PRODUCT_TYPE = 'product';
export const CROP_VIRTUAL_PRODUCT_TYPE = 'virtual-pack';

export const CROP_PRODUCT_TYPES = {
  PRODUCT: {
    label: i18n.t('CropProductTypes:product'),
    value: CROP_PRODUCT_TYPE,
  },
  VIRTUAL_PACK: {
    label: i18n.t('CropProductTypes:virtualPack'),
    value: CROP_VIRTUAL_PRODUCT_TYPE,
  },
};

export const CROP_PRODUCT_TYPES_OPTIONS = Object.values(CROP_PRODUCT_TYPES);
export const CROP_DEFAULT_PRODUCT_TYPE = CROP_PRODUCT_TYPES.PRODUCT.value;
export const MAX_CROP_QUANTITY_LIMIT = 99999;
export const MAX_CROPS_DIGITS_AFTER_DECIMAL = 3;
